/** A minőségellenőrzés feliratai és az „azóta rendeződött” logika (a típusok a D8 szerint). */

export const ELTERES_CIMKE: Record<string, string> = {
  megbizas_rejtett: 'A látogató szerint van megbízás, a CRM-ben nincs',
  szemle_rejtett: 'A látogató szerint volt szemle, a CRM-ben nincs',
  kapcsolat_vitatott: 'A látogató szerint nem keresték, a CRM-ben van kapcsolatfelvétel',
  nem_kerestek: 'A látogató szerint nem keresték, a CRM-ben sincs lépés',
  megbizas_vitatott: 'A látogató szerint nincs megbízás, a CRM-ben van',
};

/** A súlyosság: a rejtett megbízás súlyos, a rejtett szemle és a vitatott kapcsolat közepes, a többi tájékoztató. */
export type Sulyossag = 'sulyos' | 'kozepes' | 'tajekoztato';
const SULYOSSAG: Record<string, Sulyossag> = {
  megbizas_rejtett: 'sulyos', szemle_rejtett: 'kozepes', kapcsolat_vitatott: 'kozepes', nem_kerestek: 'tajekoztato', megbizas_vitatott: 'tajekoztato',
};
export const SULYOSSAG_CIMKE: Record<Sulyossag, string> = { sulyos: 'Súlyos', kozepes: 'Közepes', tajekoztato: 'Tájékoztató' };

export function elteresCimke(tipus: string): string {
  return ELTERES_CIMKE[tipus] ?? tipus;
}
export function elteresSulyossag(tipus: string): Sulyossag {
  return SULYOSSAG[tipus] ?? 'tajekoztato';
}

/** Az eltérés-típusok közül a legsúlyosabb. */
export function legsulyosabb(tipusok: readonly string[]): Sulyossag {
  const sorrend: Sulyossag[] = ['sulyos', 'kozepes', 'tajekoztato'];
  return sorrend.find((s) => tipusok.some((t) => elteresSulyossag(t) === s)) ?? 'tajekoztato';
}

export const ALLAPOT_CIMKE: Record<string, string> = {
  nyitott: 'Nyitott',
  rendben: 'Rendben',
  iroda_potolta: 'Az iroda pótolta',
  teves_valasz: 'Téves válasz',
  szerzodesszeges_gyanu: 'Szerződésszegés gyanúja',
};
export const ALLAPOT_SORREND = ['nyitott', 'rendben', 'iroda_potolta', 'teves_valasz', 'szerzodesszeges_gyanu'] as const;

export function allapotCimke(allapot: string | null): string {
  return allapot === null ? 'Nincs állapot' : ALLAPOT_CIMKE[allapot] ?? allapot;
}

const VALASZ_CIMKE: Record<string, Record<string, string>> = {
  kapcsolat: { igen: 'Igen', nem: 'Nem', nem_emlekszem: 'Nem emlékszik' },
  szemle: { igen: 'Igen', nem: 'Nem', egyeztetes_alatt: 'Egyeztetés alatt' },
  megbizas: { igen: 'Igen', nem: 'Nem', masik_irodaval: 'Másik irodával kötött', meg_nem: 'Még nem döntött' },
};

/** A látogató válaszának felirata; hiányzó válasz „–”. */
export function valaszCimke(kerdes: 'kapcsolat' | 'szemle' | 'megbizas', ertek: string | null): string {
  return ertek === null ? '–' : VALASZ_CIMKE[kerdes]![ertek] ?? ertek;
}

const RANG_CIMKE = ['', 'Új', 'Elérve', 'Szemle egyeztetve', 'Szemle megtörtént', 'Megbízás', 'Eladva'];
/** A CRM elért lépése (1–6) felirattal. */
export function rangCimke(rang: number): string {
  return RANG_CIMKE[rang] || `${rang}. lépés`;
}

/** Az eltérés-típus feloldásához elég rang; a nem feloldható típus (a látogató és a CRM ellentmond) null. */
const FELOLDO_RANG: Record<string, number | null> = {
  megbizas_rejtett: 5, szemle_rejtett: 4, nem_kerestek: 2, kapcsolat_vitatott: null, megbizas_vitatott: null,
};

/** „Azóta rendeződött”: minden eltérés-típus feloldható, és a CRM mostani elért lépése már eléri a feloldó rangot. */
export function rendezodott(tipusok: readonly string[], rangMost: number): boolean {
  if (tipusok.length === 0) return false;
  return tipusok.every((t) => {
    const rang = FELOLDO_RANG[t];
    return rang !== null && rang !== undefined && rangMost >= rang;
  });
}

/** Ennyi válasz alatt az irodai arányok még nem mérvadók (D14). */
export const KEVES_VALASZ = 5;
export function kevesValasz(valaszolt: number): boolean {
  return valaszolt < KEVES_VALASZ;
}
